module.exports = __webpack_public_path__ + "static/media/header-yandex-dark.6006fe67.svg";